import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles, Typography } from "@material-ui/core";
import Skeleton from "@mui/material/Skeleton";
const useStyles = makeStyles({
  "@global": {
    "*::-webkit-scrollbar": {
      width: "0.4rem",
      marginRight: "5rem",
    },

    "*::-webkit-scrollbar-track": {
      background: "	#000056",
    },

    "*::-webkit-scrollbar-thumb": {
      background: "white",
      borderRadius: "1.5rem",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  main: {
    color: "white",
    background: "#100041",
    marginTop: "5rem",
    paddingBottom: "3rem",
  },
  tableMain: {
    width: "96%",
    border: "0.1rem white solid",
    borderBottom: "none",
    height: "100vh",
    margin: "2%",
    textAlign: "center",
  },
  tableRow: {
    height: "20vh",
    display: "flex",
  },
  tableColumn1: {
    width: "30%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRight: "0.1rem white solid",
    borderBottom: "0.1rem white solid",
  },
  tableColumn2: {
    fontFamily: "times new roman",
    width: "70%",
    overflow: "auto",
    padding: "1rem 2rem",
    borderBottom: "0.1rem white solid",
    overflowX: "none",
    display: "flex",
    justifyContent: "center",
    textAlign: "justify",
  },
  btn: {
    fontSize: "1.6rem",
    color: "black",
    border: "0.15rem solid grey",
    background: "white",
    width: "20rem",
    height: "3rem",
    borderRadius: "0.6rem",
    "&:hover": {
      cursor: "pointer",
      transform: "scale(1.1)",
    },
  },
  skeletonDiv: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  skeRow: {
    width: "62.5vw",
    height: "1.2rem",
  },
});
const Disease = (disease) => {
  const [loading, setLoading] = useState(false);

  const [response, setResponse] = useState({
    treatment: "No Data Found",
    name: "No Data Found",
    prevention: "No Data Found",
    transmission: "No Data Found",
    facts: ["No Data Found"],
  });
  const dis = disease.data;
  useEffect(() => {
    setLoading(true);

    const apiCall = async () => {
      try {
        const res = await axios.get(
          `https://disease-info-api.herokuapp.com/diseases/${dis}.json`
        );
        setResponse(res.data.disease);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        console.log(error);
      }
    };

    dis && apiCall();
  }, [dis]);

  const classes = useStyles();

  const Search = () => {
    window.location.reload();
    window.scrollTo(0, 0);
  };

  return (
    <>
      {dis && (
        <div className={classes.main}>
          <div className={classes.tableMain}>
            <div className={classes.tableRow}>
              <div className={classes.tableColumn1}>
                <Typography variant="h4">Name</Typography>
              </div>
              <div className={classes.tableColumn2}>
                {loading ? (
                  <div className={classes.skeletonDiv}>
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "35vw",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "none",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "none",
                      }}
                    />
                  </div>
                ) : response.name ? (
                  <Typography className={classes.typo} variant="h6">
                    {response.name}
                  </Typography>
                ) : (
                  <Typography className={classes.typo} variant="h6">
                    No Data Found
                  </Typography>
                )}
              </div>
            </div>
            <div className={classes.tableRow}>
              <div className={classes.tableColumn1}>
                <Typography variant="h4">Treatment</Typography>
              </div>
              <div className={classes.tableColumn2}>
                {loading ? (
                  <div className={classes.skeletonDiv}>
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "30vw",
                      }}
                    />
                  </div>
                ) : response.treatment ? (
                  <Typography variant="h6">{response.treatment}</Typography>
                ) : (
                  <Typography variant="h6">No Data Found</Typography>
                )}
              </div>
            </div>
            <div className={classes.tableRow}>
              <div className={classes.tableColumn1}>
                <Typography variant="h4">Prevention</Typography>
              </div>
              <div className={classes.tableColumn2}>
                {loading ? (
                  <div className={classes.skeletonDiv}>
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "40vw",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "none",
                      }}
                    />
                  </div>
                ) : response.prevention ? (
                  <Typography variant="h6">{response.prevention}</Typography>
                ) : (
                  <Typography variant="h6">No Data Found</Typography>
                )}
              </div>
            </div>
            <div className={classes.tableRow}>
              <div className={classes.tableColumn1}>
                <Typography variant="h4">Transmission</Typography>
              </div>
              <div className={classes.tableColumn2}>
                {loading ? (
                  <div className={classes.skeletonDiv}>
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "20vw",
                      }}
                    />
                  </div>
                ) : response.transmission ? (
                  <Typography variant="h6">{response.transmission}</Typography>
                ) : (
                  <Typography variant="h6">No Data Found</Typography>
                )}
              </div>
            </div>
            <div className={classes.tableRow}>
              <div className={classes.tableColumn1}>
                <Typography variant="h4">Facts</Typography>
              </div>
              <div className={classes.tableColumn2}>
                {loading ? (
                  <div className={classes.skeletonDiv}>
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "55vw",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "#606060",
                        width: "45vw",
                      }}
                    />
                    <Skeleton
                      className={classes.skeRow}
                      style={{
                        background: "none",
                      }}
                    />
                  </div>
                ) : response.facts[0] !== "No Data Found" ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {response.facts.map((item, i) => {
                      return (
                        <Typography variant="h6" key={i}>
                          &#8226; {item}
                        </Typography>
                      );
                    })}
                  </div>
                ) : (
                  <Typography variant="h6">{response.facts[0]}</Typography>
                )}
              </div>
            </div>
          </div>
          <center>
            <button className={classes.btn} onClick={Search}>
              Search Another Disease
            </button>
          </center>
        </div>
      )}
    </>
  );
};

export default Disease;
